import {en} from './en';
import {tr} from './tr';

export const Languages = {
	en: en,
	tr: tr
};